import { combine, withContext, withCallbacks } from 'react-hooks-combine'
import { withTableController } from 'shared/hooks'
import { StoreContext } from 'store/context'
import { ServicesContext } from 'services/context'
import { toaster } from 'utils/toast-wrapper'
import controlTeamAthletesComponent from './component'

export const controlTeamAthletes = combine(
  withTableController({ id: 'team-athletes-table' }),
  withContext('appStore', StoreContext),
  withContext(
    'adminAthletesService',
    ServicesContext,
    ({ adminAthletesService }) => adminAthletesService
  ),
  withContext(
    'adminTeamsService',
    ServicesContext,
    ({ adminTeamsService }) => adminTeamsService
  ),
  withCallbacks(
    {
      onAddAthleteToTeam:
        ({ adminAthletesService, table, appStore }) =>
        (id, teamId) => {
          const params = { id, teamId }
          adminAthletesService.addAthleteToTeam(params).then((res) => {
            appStore.adminTeams.updateTeamAthletesIds(res.athletesIds)
            table.refresh()
            toaster.success('Athlete has been added!')
          })
        },
      onRemoveAthleteFromTeam:
        ({ adminAthletesService, table, appStore }) =>
        (id, teamId) => {
          const params = { id, teamId }
          adminAthletesService.removeAthleteFromTeam(params).then((res) => {
            appStore.adminTeams.updateTeamAthletesIds(res.athletesIds)
            table.refresh()
            toaster.success('Athlete has been removed!')
          })
        },
    },
    []
  )
)(controlTeamAthletesComponent)
